module.exports = __webpack_public_path__ + "static/media/amazon-logo.ba74832d.png";